import axios from 'axios';

export default {
    getLatestVersion() {
        return axios.get(window.API_BASE + '/latest-version');
    }
}
